var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoggedUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.894,
    height: 19,
    viewBox: "0 0 31.894 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#43b02a;}.b{stroke:#43b02a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-274 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.5,8.256a2.494,2.494,0,1,1-2.494,2.494A2.493,2.493,0,0,1,15.5,8.256m0,10.688c3.527,0,7.244,1.734,7.244,2.494v1.306H8.256V21.438c0-.76,3.717-2.494,7.244-2.494M15.5,6a4.75,4.75,0,1,0,4.75,4.75A4.749,4.749,0,0,0,15.5,6Zm0,10.688c-3.171,0-9.5,1.591-9.5,4.75V25H25V21.438C25,18.279,18.671,16.688,15.5,16.688Z",
    transform: "translate(268 -4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.219,15.264l3.8-3.807a.716.716,0,0,1,1.015,0,.725.725,0,0,1,0,1.018l-4.31,4.313a.718.718,0,0,1-.991.021L6.4,12.479a.719.719,0,0,1,1.015-1.018Z",
    transform: "translate(289.074 -0.746)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoggedUser);
export default __webpack_public_path__ + "static/media/LoggedUser.b067755c83b31b418180a27125c46218.svg";
export { ForwardRef as ReactComponent };